module.exports = __webpack_public_path__ + "static/img/logo-tkitchen-500x500.086a200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-tkitchen-500x500.png
// module id = 4JSN
// module chunks = 42